function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u624B\u673A");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u6211\\u4EEC",
  transform: "translate(-1126.000000, -273.000000)",
  fill: "#1B1464",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u65B9\\u5F0F",
  transform: "translate(1126.000000, 229.000000)"
}, React.createElement("path", {
  d: "M7.69546135,59.9526166 L16.6954614,59.9526166 L16.6954614,48.9075738 L7.69546135,48.9075738 L7.69546135,59.9526166 Z M11.9910141,61.8870347 C11.3799743,61.8870347 10.8767651,62.3902439 10.8767651,63.0192554 C10.8767651,63.648267 11.3799743,64.1514762 11.9910141,64.1514762 C12.6020539,64.1514762 13.1052632,63.648267 13.1052632,63.0192554 C13.1052632,62.3902439 12.6020539,61.8870347 11.9910141,61.8870347 Z M18.9820282,64.9781771 C18.9820282,65.5353017 18.5327343,65.9845956 17.9756098,65.9845956 L6.00641849,65.9845956 C5.44929397,65.9845956 5,65.5353016 5,64.9781771 L5,47.0064185 C5,46.449294 5.44929397,46 6.00641849,46 L17.9935815,46 C18.550706,46 19,46.449294 19,47.0064185 L19,64.9781771 L18.9820282,64.9781771 Z",
  id: "Shape"
}))));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.cff8ca4c.svg";
export { ForwardRef as ReactComponent };